import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import { FilterRouter } from 'components/FilterView';
import { AddJitApprovalPolicy } from 'containers/Jit/Setup/Components/ApprovalPolicy/AddJitApprovalPolicy';
import { ApprovalPolicies } from 'containers/Jit/Setup/Components/ApprovalPolicy/ApprovalPolicies';
import { EditJITApprovalPolicy } from 'containers/Jit/Setup/Components/ApprovalPolicy/EditJITApprovalPolicy';
import { EnableDataAccessManagement } from 'containers/Jit/Setup/Components/EnableDataAccessManagement';
import { JitAddAccountModal } from 'containers/Jit/Setup/Components/JitAddAccountModal';
import { JITConfiguration } from 'containers/Jit/Setup/Components/JITConfiguration';
import { jitSetupSaga } from 'containers/Jit/Setup/saga';
import { actions, reducer, sliceKey } from 'containers/Jit/Setup/slice';
import { useInjector } from 'utils/inject';

interface Props {
  basePath?: string;
}

export const Setup = ({ basePath = '/jit/setup' }: Props) => {
  useInjector(sliceKey, reducer, jitSetupSaga);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      actions.getJitAccountList({
        q: {},
      }),
    );
  }, [dispatch]);

  return (
    <Routes>
      <Route element={<FilterRouter path={basePath} />}>
        <Route index element={<JITConfiguration basePath={basePath} />} />
      </Route>
      <Route element={<FilterRouter path={`${basePath}/add`} />}>
        <Route path="add" element={<JitAddAccountModal />} />
      </Route>
      <Route
        element={
          <FilterRouter path={`${basePath}/enable-data-access/:provider/:id`} />
        }
      >
        <Route
          path="enable-data-access/:provider/:id"
          element={<EnableDataAccessManagement />}
        />
      </Route>
      <Route
        element={<FilterRouter path={`${basePath}/approval-policy/add`} />}
      >
        <Route path="approval-policy/add" element={<AddJitApprovalPolicy />} />
      </Route>
      <Route
        element={
          <FilterRouter path={`${basePath}/approval-policy/edit/:uuid`} />
        }
      >
        <Route
          path="approval-policy/edit/:uuid"
          element={<EditJITApprovalPolicy />}
        />
      </Route>
      <Route element={<FilterRouter path={`${basePath}/approval-policy`} />}>
        <Route path="approval-policy" element={<ApprovalPolicies />} />
      </Route>
    </Routes>
  );
};
